import { IAccountStatementBE } from '@trader/api';
import { IAccountStatementAction } from './../index';

export const defaultAccountState: IAccountStatementBE = {
  openPositions: [],
  grossProfit: 0,
  grossLoss: 0,
  netProfit: 0,
  profitFactor: 0,
  expectedPayoff: 0,
  totalTrades: 0,
  shortTrades: {
    percent: 0,
    value: 0,
  },
  longTrades: {
    percent: 0,
    value: 0,
  },
  profitTrades: {
    percent: 0,
    value: 0,
  },
  lossTrades: {
    percent: 0,
    value: 0,
  },
  largestTrade: 0,
  largestLossTrade: 0,
  avgProfitTrade: 0,
  avgLossTrade: 0,
  maxConsecutiveWins: 0,
  maxConsecutiveLosses: 0,
  maxConsecutiveProfit: 0,
  maxConsecutiveLoss: 0,
  avgConsecutiveWins: 0,
  avgConsecutiveLosses: 0,
  balanceChart: [],
  balanceHistory: [],
  costsOverview: {
    activeTrading: {
      openCommissions: 0,
      closeCommissions: 0,
      spread: 0,
    },
    closeTrading: {
      openCommissions: 0,
      closeCommissions: 0,
      spread: 0,
    },
    totalTrading: {
      openCommissions: 0,
      closeCommissions: 0,
      spread: 0,
    },
    activeAdjustments: {
      swap: 0,
      dividends: 0,
      wht: 0,
    },
    closeAdjustments: {
      swap: 0,
      dividends: 0,
      wht: 0,
    },
    totalAdjustments: {
      swap: 0,
      dividends: 0,
      wht: 0,
    },
  },
  absoluteDrawdown: 0,
  maxDrawdown: {
    percent: 0,
    value: 0,
  },
  relativeDrawdown: {
    percent: 0,
    value: 0,
  },
  summary: {
    balance: 0,
    equity: 0,
    grossPl: 0,
    realizedPl: 0,
    usedMargin: 0,
    marginFree: {
      percent: 0,
      value: 0,
    },
    mcLevel: 0,
    deposit: 0,
    withdrawal: 0,
    adjustment: 0,
    net: 0,
  },
};

export const defaultActions: Array<IAccountStatementAction> = [
  {
    id: 0,
    description: 'Buy',
  },
  {
    id: 1,
    description: 'Sell',
  },
  {
    id: 2,
    description: 'Balance',
  },
  {
    id: 3,
    description: 'Credit',
  },
  {
    id: 4,
    description: 'Additional charges/withdrawals',
  },
  {
    id: 5,
    description: 'Correcting',
  },
  {
    id: 6,
    description: 'Bonuses',
  },
  {
    id: 7,
    description: 'Commission',
  },
  {
    id: 8,
    description: 'Daily commission',
  },
  {
    id: 9,
    description: 'Monthly commission',
  },
  {
    id: 10,
    description: 'Daily agent commission',
  },
  {
    id: 11,
    description: 'Daily agent commission',
  },
  {
    id: 12,
    description: 'Accrual of annual interest',
  },
];
